import { ReactNode } from 'react';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { range } from '@sorare/core/src/lib/arrays';

import { RecommendationTitle } from '../RecommendationTitle';
import { RecommendationSkeleton } from '../ui';

const Root = styled(Horizontal)`
  flex-wrap: wrap;
  width: 100%;
  align-items: stretch;
`;

type Props = {
  items: ReactNode[];
  loading: boolean;
  title: ReactNode;
  extra?: ReactNode;
  background?: string;
};

export const Row = ({ items, loading, title, extra, background }: Props) => {
  if (!loading && items.length === 0) return null;
  return (
    <Root gap={2}>
      {loading ? (
        range(6).map(i => <RecommendationSkeleton key={i} />)
      ) : (
        <>
          <RecommendationTitle
            title={title}
            background={background}
            extra={extra}
          />
          {items.map(i => i)}
        </>
      )}
    </Root>
  );
};
